'use strict';

var React = require('react');
var component$1 = require('../Text/component.js');
var component = require('../Tooltip/component.js');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
var useIsTruncated = require('../../hooks/useIsTruncated.js');
var styles = require('./styles.js');
var types = require('./types.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Chip = React.forwardRef(({ disabled = false, icon, label, textAlign = 'center', onRemove, onIconClick, iconPosition = 'left', removeIcon = 'clear-circle-filled', removeIconPosition = 'right', variant = types.chipVariants.default, tooltipPlacement = 'top-left', ...props }, ref) => {
    const chipRef = useRefAndForward.useRefAndForward(null, ref);
    const [tooltipTarget, setTooltipTarget] = React.useState(null);
    React.useLayoutEffect(() => {
        if (chipRef.current)
            setTooltipTarget(chipRef.current);
    }, [chipRef]);
    const labelRef = React.useRef(null);
    const isLabelTruncated = useIsTruncated.useIsTruncated(labelRef.current);
    const removeIconElement = onRemove && (React__default.default.createElement(styles.RemoveIcon, { disabled: disabled, name: removeIcon, onClick: disabled ? undefined : onRemove }));
    const customIcon = icon && (React__default.default.createElement(styles.StylizedCustomIcon, { name: icon, disabled: disabled, onClick: disabled ? undefined : onIconClick }));
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(styles.ChipStyled, { textAlign: textAlign, disabled: disabled, variant: variant, ref: chipRef, ...props },
            removeIconPosition === 'left' && removeIconElement,
            iconPosition === 'left' && customIcon,
            label && React__default.default.createElement(styles.ChipContentStyled, { ref: labelRef }, label),
            iconPosition === 'right' && customIcon,
            removeIconPosition === 'right' && removeIconElement),
        isLabelTruncated && (React__default.default.createElement(component.Tooltip, { placement: tooltipPlacement, target: tooltipTarget },
            React__default.default.createElement(component$1.Text, { variant: "body-lighter" }, label)))));
});

exports.Chip = Chip;
//# sourceMappingURL=component.js.map
